import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { BaseCta } from './BaseCta';

export const BuyCta = ({ className, onClick }) => (
  <BaseCta className={classNames(className, 'bt--primary bt--outline')} onClick={onClick}>
    <FormattedMessage id="schedule.cta.buy" defaultMessage="Buy" />
  </BaseCta>
);

BuyCta.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
